export default __webpack_public_path__ + "static/media/car-seat 1.91341c4b.svg";